"use strict";
exports.__esModule = true;
exports.isJSONPointer = void 0;
function isJSONPointer(string) {
    return string === '' || string.startsWith('/');
}
exports.isJSONPointer = isJSONPointer;
